<template>
  <div
    id="re-order"
    v-if="$auth.check()"
    style="box-shadow: rgba(0, 0, 0, 0.3) 0px 20px 22px 0px;"
    class="xs-fill-white"
  >
    <div class="xs-flex xs-z-300 p-10 pt-5">
      <h4>{{ $t("your_last_order") }}</h4>
    </div>
    <div class="p-10 pb-0" v-if="reOrderItems.length > 0">
      <label class=" last-address btn--secondary btn--lg w-full">
        {{
          result.orderType == $const.DELIVERY.charAt(0)
            ? $t("delivery_to") + " " + result.address
            : $t("take_away") + " " + result.outletAddress
        }}
      </label>
    </div>
    <div v-for="(reOrderItem, i) in reOrderItems" :key="i">
      <div
        id="item-order"
        class="xs-flex xs-z-300 p-10 pt-5 item-re-order"
        v-if="reOrderItem.uuid != $const.MOBILE_EFTPOS_FEE"
      >
        <span>{{ reOrderItem.quantity }}x </span>
        <span class="mr-l-4">
          {{
            reOrderItem.items &&
            reOrderItem.items[0].first &&
            reOrderItem.items[0].first.name &&
            reOrderItem.items.length <= 1
              ? reOrderItem.items[0].first.name
              : ""
          }}
          {{ reOrderItem.name }}
          <p
            v-for="(item, i) in reOrderItem.items"
            :key="i + 'L'"
            v-if="reOrderItem.items.length > 1"
            class="dpl-block"
          >
            {{ item.first && item.first.name ? item.first.name : "" }}
            {{ item.name }}
          </p>
        </span>
        <span class="price fl-right"
          >{{ $const.CURRENCY }}{{ reOrderItem.price }}</span
        >
      </div>
      <div v-if="i == limitShowMore">
        <a
          href="javascript:void(0)"
          class="xs-flex xs-z-300 p-10 pt-5 color-view-more"
          @click="showAll()"
          v-if="showViewMore"
        >
          <span
            >{{
              viewMore && reOrderItems.length > limitShowMore
                ? $t("reorder.view_more")
                : $t("reorder.view_less")
            }}
            <i
              class="fa header-time__arrow--down aline-mid"
              :class="
                viewMore && reOrderItems.length > limitShowMore
                  ? 'fa-angle-down'
                  : 'fa-angle-up'
              "
            ></i>
          </span>
        </a>

        <div class=" xs-flex xs-z-300 p-10 pt-5">
          <div
            id="order-last-order"
            class="btn btn--primary pt-10 btn-re-order"
            v-on:click.stop="checkValidOutlet"
          >
            <div class="fw-normal fl-left mb-5">{{ $t("reorder.order") }}</div>
            <div class="fw-normal fl-right mb-5">
              {{ $const.CURRENCY
              }}{{
                reOrderItem.uuid == $const.MOBILE_EFTPOS_FEE
                  ? subTotal - 1
                  : subTotal
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ModalDelivery from "../popup/ModalDelivery.vue";
import ConfirmOrderAdvance from "../popup/ConfirmOrderAdvance.vue";
import { mapActions } from "vuex";
import * as action from "../../store/actions";
export default {
  data() {
    return {
      reOrderItems: [],
      arrItems: [],
      viewMore: true,
      showViewMore: true,
      limitShowMore: this.$const.LIMIT_VIEW_MORE,
      subTotal: 0,
      disposition: {},
      location_code: "",
      params: {
        cart_uuid: "",
        last_cart_uuid: "",
        order_type: "",
        outlet_id: "",
        order_time: "",
        advance_order: "",
        outlet_code: ""
      },
      oldOrder: {},
      result: {
        outletAddress: "",
        orderType: "",
        locationName: "",
        prefectureName: "",
        cityName: "",
        villeageName: "",
        st: "",
        outletId: "",
        outletCode: "",
        addressCode: "",
        subtradezoneid: "",
        streetName: "",
        postalCode: "",
        streetNumber: "",
        city: "",
        address: "",
        lat: "",
        long: ""
      }
    };
  },
  created() {
    this.getOldUUID();
  },
  beforeDestroy () {
    this.$root.$off('onCheckValidOutletReOrder')
  },
  mounted () {
    let vm = this
    this.$root.$on('onCheckValidOutletReOrder', (data) => {
      vm.checkValidOutlet()
    })
  },
  methods: {
    ...mapActions({
      setDisposition: action.SET_DISPOSITION,
      setShowModalTakeAwayLess: action.SET_SHOW_MODAL_TAKE_AWAY_LESS
    }),
    getOldUUID() {
      let vm = this;
      let params = {
        limit: 1,
        page: 1,
        sort_by: "updated_at",
        order_by: "desc"
      };
      this.axios.apiOrder.listOrderByUser(
        params,
        function(response) {
          let old_uuid = response.data.data.items
            ? response.data.data.items[0].uuid
            : "";
          vm.location_code = response.data.data.items
            ? response.data.data.items[0].address_code2
            : "";
          vm.getLastOrder(old_uuid);
        },
        function(err) {
          console.log("err_reOder", err);
        }
      );
    },
    searchOutletByLatLng(lng, lat) {
      let vm = this
        let val = lng + ',' + lat
        let data = {location: val, disposition: 'D', limit: 10}
       
        vm.axios.apiOutlet.checkLocation(data, function (response) {
          let outletList = response.data.data.items
          vm.result.outletAddress = outletList[0].address
          vm.result.villeageName = outletList[0].villeage_name
          vm.result.outletId = outletList[0].id
          vm.result.outletCode = outletList[0].code
        }, function (error) {
          console.log(`error: ${error}`)
          vm.evenTrackingNotInDeliveryZone(vm.searchAutoComplete, lat, lng)
        })
      },
    getLagLngByAddress(address) {
      let vm = this
      let geocoder = new google.maps.Geocoder()
      geocoder.geocode({'address': address}, function (results, status) {
        vm.result.lat = results[0].geometry.location.lat()
        vm.result.long = results[0].geometry.location.lng()
        vm.searchOutletByLatLng(vm.result.long, vm.result.lat)
      })
    },
    getLastOrder(uuid) {
      let vm = this;
      this.axios.apiOrder.getOrder(
        uuid,
        function(response) {  
          vm.oldOrder = response.data.data.item;
          let deliveryAddress = vm.oldOrder.delivery_address;
          vm.result.prefectureName = (deliveryAddress && deliveryAddress.prefecture) || "";
          vm.result.cityName = (deliveryAddress && deliveryAddress.city) || "";
          vm.result.villeageName = (deliveryAddress && deliveryAddress.villeage_name) || "";
          vm.result.locationName = deliveryAddress && deliveryAddress.address;
          vm.result.outletAddress = vm.oldOrder.outlet_name;
          vm.result.orderType = vm.oldOrder.order_type;
          vm.result.outletId = vm.oldOrder.outlet_id
          vm.result.outletCode = vm.result.outletCode
          vm.result.addressCode = vm.location_code || "";
          vm.result.st = (deliveryAddress && deliveryAddress.house_no) || "";
          vm.result.landmark = (deliveryAddress && deliveryAddress.landmark) || "";
          vm.result.unitNo = (deliveryAddress && deliveryAddress.unit_no) || "";
          vm.result.streetName = (deliveryAddress && deliveryAddress.street_name) || "";
          vm.result.subtradezoneid = (deliveryAddress && deliveryAddress.subtradezoneid) || "";
          vm.result.postalCode = (deliveryAddress && deliveryAddress.zip_code) || "";
          vm.result.streetNumber = (deliveryAddress && deliveryAddress.street_number) || "";
          vm.result.city = (deliveryAddress && deliveryAddress.city) || "";
          vm.result.address = (deliveryAddress && deliveryAddress.address) || "";
          // vm.result.lat = (deliveryAddress && deliveryAddress.lat) || "";
          // vm.result.long = (deliveryAddress && deliveryAddress.long) || "";
          vm.arrItems = vm.oldOrder ? vm.oldOrder.order_items : [];
          vm.subTotal = vm.oldOrder ? vm.oldOrder.sub_total : 0;
          vm.reOrderItems = vm.arrItems.slice(0, 3);
          if (vm.arrItems.length <= vm.limitShowMore) {
            vm.limitShowMore = vm.reOrderItems.length - 1;
            vm.showViewMore = false;
          } else {
            vm.limitShowMore = vm.$const.LIMIT_VIEW_MORE - 1;
            vm.showViewMore = true;
          }

          if(vm.result.orderType === vm.$const.DELIVERY.charAt(0)) {
            vm.getLagLngByAddress(vm.result.locationName)
          }
          
        },
        function(err) {
          console.log("err_getLastOrder", err);
        }
      );
    },
    showAll() {
      this.viewMore = !this.viewMore;
      if (!this.viewMore) {
        this.reOrderItems = this.arrItems;
        this.limitShowMore = this.arrItems.length - 1;
        return;
      }
      this.reOrderItems = this.arrItems.slice(0, 3);
      this.limitShowMore = this.$const.LIMIT_VIEW_MORE - 1;
    },
    reOrder(cart_uuid) {
      let vm = this;
      vm.params.cart_uuid = cart_uuid;
      vm.params.last_cart_uuid = vm.oldOrder.cart_uuid;
      vm.params.order_type = vm.result.orderType;
      vm.params.outlet_id = vm.result.outletId;
      vm.params.order_time = vm.convertDateTimeToUTC("");
      vm.params.advance_order = 0;
      vm.params.outlet_code = vm.result.outletCode;
      if (vm.$session.get("disposition")) {
        vm.params.order_time = vm.convertDateTimeFromTimezoneToUTC(
          vm.$disposition.getByKey(vm, "timezone", ""),
          vm.$disposition.getByKey(vm, "collectionTimeValue", "")
        );
        vm.params.advance_order =
          vm.$disposition.getByKey(vm, "advanceOrder", 0) || 0;
      }
      vm.axios.apiCart.reOrderCart(
        vm.params,
        function(response) {
          if (!response.data.status) return;
          let cart = response.data.data.item;
          // vm.$cart.insert(this, cart)
          vm.$session.remove("cart"); 
          vm.$session.set("cart", cart);
          vm.$root.$emit("cartUpdate");
          if (vm.isMobile()) {
            vm.$root.$emit("showHideCart", true);
          } else {
            vm.$router.push({ 'name': 'category', 'params': { 'slug': vm.$const.MENU_DEFAULT } })
          }
          vm.$root.$emit("onProcessChangeCategory");
        },
        function(error) {
          vm.sendEventGA(vm, 'CVR', `reOrder_Last_Order_error_${error.error.code}`, 'error', null, false)
          let message = vm.getMessageFromGms(error)
          vm.$modal.show('dialog', {
            text: message,
            buttons: [
              {
                title: vm.$t('button_close')
              }
            ]
          })
        }
      );
    },
    createCart() {
      let vm = this;
      vm.axios.apiCart.createCart(
        {
          outlet_code: vm.result.outletCode,
          order_type: vm.result.orderType,
          order_time: !vm.$session.get("disposition")
            ? vm.convertDateTimeToUTC("")
            : vm.convertDateTimeFromTimezoneToUTC(
                vm.$disposition.getByKey(vm, "timezone", ""),
                vm.$disposition.getByKey(vm, "collectionTimeValue", "")
              ),
          advance_order: vm.$disposition.getByKey(vm, "advanceOrder", 0) || 0
        },
        function(response) {
          let cart_uuid = response.data.data.item.uuid;
          if (!cart_uuid) {
            console.log("cart_uuid is null");
            return;
          }
          vm.reOrder(cart_uuid);
        },
        function(error) {
          vm.sendEventGA(vm, 'CVR', `reOrder_Last_Order_createCart_error_${error.error.code}`, 'error', null, false)
          let message = vm.getMessageFromGms(error)
          vm.$modal.show('dialog', {
            text: message,
            buttons: [
              {
                title: vm.$t('button_close')
              }
            ]
          })
        }
      );
    },
    /**
     * Checking outlet is available
     * */
    checkValidOutlet() {
      // check time outlet
      var vm = this;
      let data = {
        order_type: vm.result.orderType,
        order_time: vm.convertDateTimeToUTC(
          vm.$disposition.getByKey(vm, "collectionTimeText", "")
        ),
        advance_order: vm.$disposition.getByKey(vm, "advanceOrder", 0) || 0,
        outlet_id: vm.result.outletId,
        address: vm.result.address,
        lat: vm.result.lat,
        long: vm.result.long
      };

      vm.axios.apiOutlet.checkOutletAvailable(
        data,
        function(response) {
          response = response.data;
          if (response.status) {
            let data = vm.$disposition.get(vm);
            response = response.data.item;

            if (!vm.result.prefectureName && !vm.result.villeageName) {
              let arrAddress = vm.result.address.split(",");
              vm.result.prefectureName = arrAddress[3];
              vm.result.villeageName = [arrAddress[1], arrAddress[2]].join(",");
            }
            // set data
            data.prefectureName = vm.result.prefectureName || "";
            data.cityName = vm.result.cityName || "";
            data.villeageName = vm.result.villeageName || "";
            data.st = vm.result.st || "";
            data.lat = vm.result.lat;
            data.long = vm.result.long;
            data.postalCode = response.zip || vm.result.postalCode;
            data.locationName = vm.result.locationName;
            data.outletAddress = response.address;
            data.orderType =
              vm.result.orderType == vm.$const.DELIVERY.charAt(0)
                ? vm.$const.DELIVERY
                : vm.$const.CARRYOUT;
            data.outletId = response.id;
            data.outletName = response.name;
            data.outletCode = response.code;
            data.advanceOrder =
              vm.$disposition.getByKey(vm, "advanceOrder", 0) || 0;
            data.tier = response.tier;
            vm.$disposition.set(vm, data);
            // vm.$router.push({ 'name': 'category', 'params': { 'slug': vm.$const.MENU_DEFAULT } })
            let cart = vm.$cart.get(vm);
            if (cart.uuid && cart.data.length > 0) {
              vm.$modal.show("dialog", {
                text: vm.$t("confirm.remove_cart"),
                buttons: [
                  {
                    title: vm.$t("button_yes"),
                    handler: () => {
                      vm.$modal.hide("dialog");
                      vm.createCart();
                      
                    }
                  },
                  {
                    title: vm.$t("button_close")
                  }
                ]
              });
            } else {
              vm.createCart();
            }
          } else if (response.message && response.message != "") {
            vm.$notify({
              type: "warn",
              title: response.message
            });
          }
        },
        function(error) {
          let message = vm.getMessageFromGms(error);
          vm.eventTrackingLocalisationError({
            id: "error-localization",
            error: "invalid-localisation"
          });
          vm.eventTrackingFailureLocalised()
          if (error.code === vm.$const.LOCALIZATION_CODE.HUT19) {
            vm.$modal.show(ModalDelivery, {
              message: message,
              methodSearch: vm.$const.DEFAULT_CONFIG_APP,
              hideCollectionButton: false,
              chooseAnotherDelivery: function() {
                vm.openmapHaveAddress(
                  vm.lat || vm.locationCenter.lat,
                  vm.lng || vm.locationCenter.lng
                );
              }
            });
          } else if (error.code === vm.$const.LOCALIZATION_CODE.HUT20) {
            vm.$modal.show(ModalDelivery, {
              message: message,
              methodSearch: vm.$const.DEFAULT_CONFIG_APP_2,
              hideCollectionButton: true
            });
          } else {
            vm.$modal.show(ConfirmOrderAdvance, {
                message: message,
                outletId: vm.result.outletId,
                outletDataZip: vm.result.zip_code,
                outletDataLocalization: vm.result,
                orderType: vm.result.orderType,
                gotoFindHut: "",
                reOrder: 1
            });
          }
        }
      );
    }
  }
};
</script>
<style scoped>
.price {
  margin-left: auto;
}
#item-order > span {
  font-weight: bold;
}
.last-address {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3%;
  font-weight: 400;
  text-align: center;
  background-color: #f5f7f9;
  border: 1px solid transparent;
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 4px;
}
.item-re-order {
  font-family: "Open Sans";
  font-weight: 400;
  font-size: 14px;
}
.mr-l-4 {
  margin-left: 4%;
}
span > p {
  margin-top: 5%;
  display: block;
  font-weight: 400 !important;
}
.btn-re-order {
  border-radius: 3px;
  line-height: 1;
  width: 100%;
}
.fl-left {
  float: left;
}
.fl-right {
  float: right;
}
.aline-mid {
  font: normal normal normal 18px/1.2 "FontAwesome" !important;
  margin-left: 5px;
}
.color-view-more {
  color: #70a401;
}
</style>



// WEBPACK FOOTER //
// src/components/home/HomeReOrder.vue